import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UserContainer from 'components/user/container/UserContainer';
import Table from 'components/table/Table';
import { formatDate } from 'controls/utils';
import { Language } from 'language/Language';
import 'components/table/_Table.scss';
import { subscriptionsStrings } from './strings';

const Subscriptions = () => {
  const subscription = useSelector((state) => state.subscription);
  const siteSubscription = useSelector((state) => state.siteInfo?.subscription);

  const language = Language();
  const headers = [subscriptionsStrings.english.status, subscriptionsStrings.english.type, subscriptionsStrings.english.total, subscriptionsStrings.english.nextRenewal, subscriptionsStrings.english.actions];

  return (
    <UserContainer>
      <Table>
        <>
          <Table.Header headers={headers} />
          <Table.Content>
            <>
              {subscription
                ? (
                  <div className='table-row' key={subscription.id}>
                    <div className='table-content__item order-table__item'>
                      {subscription.pausedFrom ? 'Paused' : subscription.status}
                    </div>
                    <div className='table-content__item order-table__item'>
                      <p>{subscription.type}</p>
                    </div>
                    <div className='table-content__item order-table__item'>
                      <p>{siteSubscription?.prices?.gross}</p>
                    </div>
                    <div className='table-content__item order-table__item'>
                      <p>{formatDate(moment.utc(subscription.nextRenewal).toDate())}</p>
                    </div>
                    <div className='table-content__item' style={{ maxHeight: '7rem' }}>
                      <Link
                        to='/my-account/view-subscription'
                        className='table-content__link'
                      >
                        {subscriptionsStrings[language].view}
                      </Link>
                    </div>
                  </div>
                )
                : (
                  <p style={{ marginTop: '1rem' }}>No subscription has been made yet.</p>
                )}
            </>
          </Table.Content>
        </>
      </Table>
    </UserContainer>
  );
};

export default Subscriptions;
